import { VacationDecisionModal } from '@/features/Vacations/components/VacationDecisionModal';
import type { ApprovalDecisionKind, ApprovalDecisionSubmission, ApprovalItem } from '../approvals.types';
import { DayOffDecisionModal } from './DayOffDecisionModal';

interface ApprovalDecisionModalProps {
    item: ApprovalItem | null;
    kind: ApprovalDecisionKind;
    onClose: () => void;
    onConfirm: (item: ApprovalItem, decision: ApprovalDecisionSubmission) => void;
    isSubmitting?: boolean;
}

export function ApprovalDecisionModal({
    item,
    kind,
    onClose,
    onConfirm,
    isSubmitting = false,
}: ApprovalDecisionModalProps) {
    return (
        <>
            <VacationDecisionModal
                isOpen={item?.kind === 'vacation'}
                item={item?.kind === 'vacation' ? item.item : null}
                kind={kind}
                onClose={onClose}
                onConfirm={(_vacationItem, decision) => item && onConfirm(item, decision)}
                isSubmitting={isSubmitting}
            />
            <DayOffDecisionModal
                isOpen={item?.kind === 'day_off'}
                approval={item?.kind === 'day_off' ? item : null}
                kind={kind}
                onClose={onClose}
                onConfirm={onConfirm}
                isSubmitting={isSubmitting}
            />
        </>
    );
}
